import { createSelector } from "reselect";
import * as api from "@/api/user";

const prefix = "admin/user/list";

const FETCH_START = `${prefix}/FETCH_START`;
const FETCH_FAIL = `${prefix}/FETCH_FAIL`;
const FETCH_SUCCESS = `${prefix}/FETCH_SUCCESS`;

const fetchStart = (_query) => ({ type: FETCH_START, payload: true });
const fetchSuccess = (data) => ({ type: FETCH_SUCCESS, payload: data });
const fetchFail = (err) => ({ type: FETCH_FAIL, error: true, payload: err });

export function fetchRecords(query) {
  return async (dispatch) => {
    dispatch(fetchStart(query));

    try {
      const data = await api.fetchRecords(query);
      dispatch(fetchSuccess(data));
    } catch (err) {
      dispatch(fetchFail(err));
    }
  };
}

const baseSelector = (state) => state.user.list;

export const getIsFetching = createSelector(baseSelector, (state) => state.isFetching);

export const getRecords = createSelector(baseSelector, (state) => state.records);

export const getQuery = createSelector(baseSelector, (state) => state.query);

export const getPager = createSelector(baseSelector, (state) => state.pager);

const initialState = {
  isFetching: false,
  records: [],
  query: {},
  pager: {
    count: 0,
    limit: 10,
    offset: 0,
  },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_START:
      return {
        ...state,
        // records: [],
        isFetching: true,
      };

    case FETCH_SUCCESS:
      return {
        ...state,
        records: action.payload.records,
        query: action.query,
        pager: action.payload.pager,
        isFetching: false,
        error: null,
      };

    case FETCH_FAIL:
      return {
        ...state,
        isFetching: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
